import React from 'react';
import {
  FDAccordion, FDAccordionDetails, FDAccordionTitle, FDBox, FDPaper, FDStack, FDTitleText,
} from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import PropTypes from 'prop-types';
import { useMobileOrMCLayout } from 'Hooks/useMobileLayoutOrMCLayout';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  UpdatedBalanceSheetCategoriesAccordionContent,
} from 'Views/Page/Content/Templates/HouseholdBalanceSheetPageTemplate/updatedLineItemLayout/BalanceSheetCategoriesAccordionContent';

const useStyles = buildUseStyles('BalanceSheetCategoryAccordion', () => ({
  accordionWrapperMobileOrMC: {
    '& .FD-MuiAccordionDetails-root': {
      paddingBottom: 0,
      paddingTop: 0,
    },
  },
}));

export const BalanceSheetCategoryAccordion = ({
  expanded,
  setExpanded,
  categoryResource,
  onEditLineItemClick,
  hasBigNumbers,
  isFiltering,
}) => {
  const classes = useStyles();
  const isMobileOrMC = useMobileOrMCLayout();

  const isEmpty = categoryResource.attr('lineItems').resources().list().length === 0;
  if (isEmpty && isFiltering) {
    return null;
  }

  return (
    <FDPaper padding={isMobileOrMC ? 0 : 2} appearance="flat">
      <div className={isMobileOrMC ? classes.accordionWrapperMobileOrMC : undefined}>
        <FDAccordion expanded={expanded} key={categoryResource.id()} onChange={() => setExpanded(!expanded)}>
          <FDAccordionTitle {...dataAttrs(`balance-sheet-accordion-${categoryResource.id()}`)}>
            <FDStack alignItems={'center'} justifyContent={'space-between'} flex={1}>
              <FDTitleText
                size="lg"
                value={(
                  <FDStack direction="row">
                    {
                      /* Add horizontal spacing when not in mobile so that the heading of the accordion is at the same position as the FDListItems within it */
                      isMobileOrMC ? null : <FDBox paddingX={1} />
                    }
                    {categoryResource.selectedOptionPrompt('categoryName')}
                  </FDStack>
            )}
              />
              <FDTitleText size="lg" value={categoryResource.attr('total')} />
            </FDStack>
          </FDAccordionTitle>
          <FDAccordionDetails>
            <UpdatedBalanceSheetCategoriesAccordionContent
              lineItems={categoryResource.attr('lineItems').resources().list()}
              onEditLineItemClick={onEditLineItemClick}
              hasBigNumbers={hasBigNumbers}
              isFiltering={isFiltering}
            />
          </FDAccordionDetails>
        </FDAccordion>
      </div>
    </FDPaper>
  );
};


BalanceSheetCategoryAccordion.propTypes = {
  categoryResource: PropTypes.object.isRequired,
  onEditLineItemClick: PropTypes.func.isRequired,
  expanded: PropTypes.bool.isRequired,
  setExpanded: PropTypes.func.isRequired,
  hasBigNumbers: PropTypes.bool.isRequired,
  isFiltering: PropTypes.bool.isRequired,
};
